import React, { FormEvent, useEffect, useRef, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Seo from "components/Seo";
import MorningLayout from "../../morningLayout";
import { useGetAlarm } from "hooks/morning/useGetAlarm";
import { useGetMypageInfo } from "hooks/morning/useGetMypageInfo";
import { useGetCounter } from "hooks/morning/useGetCounter";
import { AddressList, SelectAddress, SelectAddressHandle } from "../../-components/AddressBook";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import { toastErrorSyle } from "hooks/utils/util";
import { usePutDefaultAddress } from "hooks/morning/usePutDefaultAddress";
import { useMorningAuthStore } from "store/useMorningAuthStore";
import { usePostPrintAdvance } from "hooks/morning/usePostPrintAdvance";
import { usePostTrackingPopCancelPrint } from "hooks/morning/usePostTrackingPopCancelPrint";
import PrintColor from "../../-components/PrintColor";
import { ReactComponent as Alarm } from "assets/morning/icon/alarm.svg";
import { ReactComponent as RightArrow } from "assets/morning/icon/rightArrow.svg";
import { ReactComponent as Close } from "assets/morning/icon/close.svg";
import { ReactComponent as Note } from "assets/morning/icon/note.svg";
import { ReactComponent as Parcel } from "assets/morning/icon/parcel.svg";
import { ReactComponent as Message } from "assets/morning/icon/message.svg";
import { ReactComponent as Checked } from "assets/morning/icon/checked.svg";
import { useAppContext } from "context/AppContext";
import ProgressSpinner from "components/ProgressSpinner";

type Departure = {
    value?: string;
    title?: string;
    addr1?: string;
    addr2?: string;
    name?: string;
    tel?: string;
    phone?: string; // 휴대폰번호
    post?: string;
    dcode?: string;
};

const initialFormState = {
    addr1: "",
    addr2: "",
    name: "",
    tel: "",
    title: "",
    value: "",
    post: "",
    dcode: "",

    a_address: "",
    a_address_detail: "",
    a_code: "",
    a_company: "",
    a_mobile: "",
    a_name: "",
    a_post: "",
    a_tel: "",
    idx: 0,

    s_pay_kind: "1", //'지불방법 신용 : 1, 착불 : 3',

    bl_cnt: "",
};

export default function MyPage() {
    const navigate = useNavigate();
    const { isApp, appVersion } = useAppContext();
    const departureRef = useRef<HTMLDivElement | null>(null);
    const selectAddressRef = useRef<SelectAddressHandle>(null);
    const cBefPrint = useMorningAuthStore.getState().c_bef_print;
    const cCode = useMorningAuthStore.getState().c_code;
    const cCompany = useMorningAuthStore.getState().c_company;
    const cBranch = useMorningAuthStore.getState().c_branch;
    const rBranch = useMorningAuthStore.getState().c_rbranch;
    const seBranch = useMorningAuthStore.getState().c_sebranch;
    const [activeTabIndex, setactiveTabIndex] = useState(0);
    const [alarm, setAlarm] = useState(false);
    const [form, setForm] = useState(initialFormState);
    const [printData, setPrintData] = useState<any>(null);
    const { data: infoData } = useGetMypageInfo();
    const { data: alarmData } = useGetAlarm();
    const { data: counterData } = useGetCounter();
    const { mutate } = usePutDefaultAddress();
    const { mutate: printMutate, isPending } = usePostPrintAdvance();
    const { mutate: popCancelPrinMutate } = usePostTrackingPopCancelPrint();
    const [printProgressMessage, setPrintProgressMessage] = useState("");
    const responsive450 = useMediaQuery(450);

    console.log("infoData", infoData);

    const departureList: Departure[] = [
        {
            value: "1",
            title: infoData?.c_addr,
            addr1: infoData?.C_ADDR1,
            addr2: infoData?.C_ADDR2,
            name: infoData?.dname,
            tel: infoData?.C_ADDR_Tel,
            phone: infoData?.dtel,
            post: infoData?.C_Post,
            dcode: infoData?.dcode,
        },
        {
            value: "2",
            title: infoData?.c_raddr,
            addr1: infoData?.C_RADDR1,
            addr2: infoData?.C_RADDR2,
            name: infoData?.dname1,
            tel: infoData?.C_RADDR_Tel,
            phone: infoData?.dtel1,
            post: infoData?.C_RPost,
            dcode: infoData?.dcode1,
        },
        {
            value: "3",
            title: infoData?.c_seaddr,
            addr1: infoData?.C_SeADDR1,
            addr2: infoData?.C_SeADDR2,
            name: infoData?.dname2,
            tel: infoData?.C_SeADDR_Tel,
            phone: infoData?.dtel2,
            post: infoData?.C_SePost,
            dcode: infoData?.dcode2,
        },
    ];

    useEffect(() => {
        handleReset();
    }, [infoData]);

    // console.log(infoData);
    const handleAddressSelect = (item: any) => {};

    const updateDefaultAddress = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const newAddressValue = formData.get("default-addr") as string;

        mutate(
            { addrChk: newAddressValue },
            {
                onSuccess: () => {
                    toast.success("성공적으로 수정 되었습니다.");
                    // refetch();
                },
                onError: (error: any) => {
                    const message = error.message;
                    toast.error(message, toastErrorSyle);
                },
            },
        );
    };

    const handleReset = () => {
        if (infoData) {
            const selected = departureList.filter(list => list.addr1).find(item => item.value === infoData.c_addr_defalt);

            if (selected) {
                setForm(prev => ({ ...initialFormState, ...selected }));
                selectAddressRef.current?.handleReset();
            }
        }
    };

    const onClickPrint = async () => {
        if (!form.idx) {
            toast.error("도착지를 선택해주세요", toastErrorSyle);
            departureRef.current?.scrollIntoView({ behavior: "smooth" });
            return;
        }

        if (!form.bl_cnt || !form.bl_cnt.trim() || form.bl_cnt === "0" || form.bl_cnt.trim() === "0") {
            toast.error("수량을 입력해주세요", toastErrorSyle);
            return;
        }

        if (form.bl_cnt && Number(form.bl_cnt) > 100) {
            toast.error("최대 출력 수량은 100장입니다.", toastErrorSyle);
            return;
        }

        const params = {
            c_code: cCode ?? "",
            c_branch: form.value === "1" ? cBranch : form.value === "2" ? rBranch : seBranch, //'배송지역번호'
            s_kind: "H", //'발송구분 H , A'
            s_pay_kind: form.s_pay_kind, //'지불방법 신용 : 1, 착불 : 3'
            s_cnt: "1", //'수량 무조건 1'
            s_weight: "",

            // s로 시작하는 파라미터 빈 값 가능
            s_pay_company_code: "", //'요금처코드'
            s_pay_company: "", //'요금처상호명'
            s_pay_tel: "", //'요금처연락처'
            s_pay_name: "", //'요금처담당자'
            s_pay_post: "", //'요금처 우편번호'
            s_pay_address: "", //'요금처 주소1'
            s_pay_address_detail: "", //'요금처 주소2'

            a_company: cCompany ?? "", //'접수자 상호명'
            a_tel: "", //'접수자 핸드폰번호' (필수)
            a_part: "", //'접수자 부서명'
            a_part_sn: "", //'접수자 부서명 코드'
            a_name: "", //'접수자 담당자명' (필수)
            a_request: "", //'배송시 특이사항'
            a_request2: "", //'픽업시 요청사항'

            f_c_code: cCode ?? "", //'출발지 업체코드'
            f_company: cCompany ?? "", //'출발지 상호명'
            f_tel:
                form.value === "1"
                    ? (infoData?.C_ADDR_Tel ?? "")
                    : form.value === "2"
                      ? (infoData?.C_RADDR_Tel ?? "")
                      : (infoData?.C_SeADDR_Tel ?? ""), //'출발지 연락처'
            // f_name: form.name, //'출발지 담당자명'
            f_name: "", //'출발지 담당자명'
            // f_mobile: form.tel, //'출발지 휴대폰번호'
            f_mobile: "", //'출발지 휴대폰번호'
            f_post: form.post, //'출발지 우편번호'
            f_address: form.addr1, //'출발지 주소1'
            f_address_detail: form.addr2, //'출발지 주소2'
            f_dam_code: form.dcode, //'출발지 픽업담당자 코드'

            t_c_code: form.a_code, //'도착지 업체 코드'
            t_company: form.a_company, //'도착지 상호명'
            t_tel: form.a_tel, //'도착지 연락처'
            t_name: form.a_name, //'도착지 담당자명'
            t_mobile: form.a_mobile, //'도착지 휴대폰번호'
            t_post: form.a_post, //'도착지 우편번호'
            t_address: form.a_address, //'도착지 주소1'
            t_address_detail: form.a_address_detail, //'도착지 주소2'

            bl_cnt: form.bl_cnt, //'송장갯수'
        };

        // console.log(params);
        // return;

        const count = Number(params.bl_cnt) || 1; // 기본값 1장
        const results: any[] = [];

        const runPrints = async () => {
            for (let i = 0; i < count; i++) {
                let attempt = 0;
                let success = false;

                while (attempt < 4 && !success) {
                    try {
                        const res = await new Promise<any>((resolve, reject) => {
                            printMutate(
                                { ...params, bl_cnt: "1" }, // ✅ 매번 1장만 요청
                                {
                                    onSuccess: resolve,
                                    onError: reject,
                                },
                            );
                        });

                        results.push(res);
                        setPrintProgressMessage(`${i + 1} / ${count} 장 처리 중...`);
                        success = true; // 성공 플래그
                    } catch (error: any) {
                        attempt++;
                        //   console.warn(`❌ ${i + 1}번째 프린트 실패 (시도 ${attempt}/4)`);

                        if (attempt >= 4) {
                            const message = error.message || `${i + 1}번째 프린트 처리 시도 실패`;
                            toast.error(message, toastErrorSyle);
                            return; // 전체 중단
                        }

                        // 잠시 대기 후 재시도
                        await new Promise(resolve => setTimeout(resolve, 1000));
                    }
                }
            }

            // ✅ 모든 장 처리 끝난 후
            const blNumbers = results.flatMap(r => r.data.map((d: any) => "E-" + d.s_bl_no + "-001"));

            popCancelPrinMutate(
                {
                    print_number: 1,
                    chk_bl_no: blNumbers,
                },
                {
                    onSuccess: data => {
                        // console.log(data);
                        setPrintData(data);
                        // toast.success("모든 출력 완료");
                    },
                    onError: (error: any) => {
                        const message = error.message;
                        toast.error(message, toastErrorSyle);
                    },
                },
            );
        };

        runPrints();
    };

    const handleLogout = () => {
        const { logout } = useMorningAuthStore.getState();
        logout();

        if (isApp) {
            const appLogout = (window as any)?.AppLogout;
            if (appLogout?.postMessage) {
                appLogout.postMessage("logout");
            }
        }
    };

    const token = useMorningAuthStore.getState().accessToken;

    if (!token) {
        return <Navigate to="/login" />;
    }

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="마이페이지" />
            <div className={`flex flex-col relative ${!isApp && "mt-[116px]"}`}>
                <MorningLayout>
                    <div className="bg-[#f8f8f8] min-h-screen flex flex-col items-center py-12 responsive1200:px-[4%] responsive1200:py-[30px] responsive450:bg-[#F3F5F8]">
                        <div className="w-full max-w-[680px] mx-auto">
                            <p className="text-[#1b1c1e] text-[36px] font-bold responsive1200:text-[24px] responsive1200:font-[500] text-center responsive450:hidden">
                                마이페이지
                            </p>

                            <div className="bg-white items-center mt-12 px-[40px] py-[24px] rounded-[16px] flex flex-col mb-6 gap-[24px] responsive1200:my-[30px] responsive1200:px-[4%] shadow-[0px_0px_12px_0px_#CAD6DE99] responsive450:bg-transparent responsive450:shadow-none responsive450:p-0 responsive450:gap-[13px] responsive450:my-0">
                                <div className="flex justify-between w-full">
                                    <div className="flex gap-[12px] items-center flex-wrap">
                                        <p className="text-[28px] font-bold break-keep responsive450:text-[24px]">{infoData?.c_company}</p>
                                        {/* <span className="text-[18px] text-[#FF7B2E] font-[500] responsive450:text-[16px]">
                                            {infoData?.c_month_yn}
                                        </span> */}
                                    </div>
                                    <div className="relative flex items-center">
                                        <figure
                                            className="flex items-center gap-[20px] cursor-pointer"
                                            onClick={() => (responsive450 ? navigate("/mypage/alarm") : setAlarm(true))}
                                        >
                                            <div className="relative">
                                                <Alarm />
                                                {alarmData && alarmData?.length > 0 && (
                                                    <span className="w-[6px] h-[6px] rounded-full bg-new absolute top-0 left-2/3"></span>
                                                )}
                                            </div>
                                            <figcaption className="responsive450:hidden whitespace-nowrap">알림</figcaption>
                                        </figure>

                                        {alarm && (
                                            <div className="!absolute top-full right-0 bg-white w-[400px] rounded-xl shadow-[0px_0px_12px_0px_#CAD6DE99] relative overflow-hidden">
                                                <div className="flex items-center justify-between px-[16px] py-[20px]">
                                                    <p className="text-[20px] font-[500] text-[#1B1C1E]">알림</p>
                                                    <Close className="cursor-pointer" onClick={() => setAlarm(false)} />
                                                </div>
                                                <hr />
                                                <div className="max-h-[500px] overflow-y-auto">
                                                    {alarmData && alarmData?.length > 0 ? (
                                                        <>
                                                            {alarmData.map(alarm => {
                                                                return (
                                                                    <div key={alarm.bl_no} className="px-5 py-3">
                                                                        <p className="text-[#1B1C1E] mb-[8px]">{alarm.bl_no}</p>
                                                                        <p className="text-[#666666] mb-[4px]">{alarm.o_kind_text}</p>
                                                                        <p className="text-[#878A93] text-[14px]">{alarm.o_date}</p>
                                                                    </div>
                                                                );
                                                            })}
                                                        </>
                                                    ) : (
                                                        <div className="text-center py-[50px]">알림 내역 없음</div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="flex w-full responsive450:bg-white responsive450:shadow-[0px_0px_12px_0px_#CAD6DE99] responsive450:rounded-[8px] responsive450:px-[12px] responsive450:py-[16px]">
                                    <div className="flex-1 flex flex-col items-center gap-[4px]">
                                        <span className="text-[#eaebec] text-[24px] font-bold responsive450:text-[28px]">
                                            {counterData?.["오더접수"]}
                                        </span>
                                        <p className="text-[#999999] text-[14px] font-[400] responsive450:text-[13px]">오더접수</p>
                                    </div>
                                    <div className="flex items-center responsive450:hidden">
                                        <RightArrow />
                                    </div>
                                    <div className="flex-1 flex flex-col items-center gap-[4px]">
                                        <span className="text-[#eaebec] text-[24px] font-bold responsive450:text-[28px]">
                                            {counterData?.["픽업예약"]}
                                        </span>
                                        <p className="text-[#999999] text-[14px] font-[400 responsive450:text-[13px]">픽업예약</p>
                                    </div>
                                    <div className="flex items-center responsive450:hidden">
                                        <RightArrow />
                                    </div>
                                    <div className="flex-1 flex flex-col items-center gap-[4px]">
                                        <span className="text-[#eaebec] text-[24px] font-bold responsive450:text-[28px]">
                                            {counterData?.["픽업완료"]}
                                        </span>
                                        <p className="text-[#999999] text-[14px] font-[400] responsive450:text-[13px]">픽업완료</p>
                                    </div>
                                    <div className="flex items-center responsive450:hidden">
                                        <RightArrow />
                                    </div>
                                    <div className="flex-1 flex flex-col items-center gap-[4px]">
                                        <span className="text-[#eaebec] text-[24px] font-bold responsive450:text-[28px]">
                                            {counterData?.["배송중"]}
                                        </span>
                                        <p className="text-[#999999] text-[14px] font-[400] responsive450:text-[13px]">배송중</p>
                                    </div>
                                    <div className="flex items-center responsive450:hidden">
                                        <RightArrow />
                                    </div>
                                    <div className="flex-1 flex flex-col items-center gap-[4px]">
                                        <span className="text-[#eaebec] text-[24px] font-bold responsive450:text-[28px]">
                                            {counterData?.["배송완료"]}
                                        </span>
                                        <p className="text-[#999999] text-[14px] font-[400] responsive450:text-[13px]">배송완료</p>
                                    </div>
                                </div>
                            </div>

                            {responsive450 ? (
                                <div className="mt-[12px] hidden responsive450:block">
                                    <div className="flex gap-[8px]">
                                        <Link
                                            to="/mypage/info"
                                            className="flex-1 bg-[#132E47] py-[12px] rounded-[8px] text-white text-center"
                                        >
                                            업체 정보
                                        </Link>
                                        <Link
                                            to="/mypage/address"
                                            className="flex-1 bg-[#132E47] py-[12px] rounded-[8px] text-white text-center"
                                        >
                                            주소록관리
                                        </Link>
                                    </div>

                                    <div className="pt-[24px]">
                                        <p className="text-[#878A93] text-[15px] font-[500]">고객센터</p>
                                        <div className="flex gap-[8px] mt-[8px]">
                                            <Link
                                                to="/support/courier-inquiry"
                                                className="flex-1 bg-white rounded-[8px] flex flex-col items-center justify-center gap-[12px] flex-wrap py-[16px]"
                                            >
                                                <Note />
                                                <p className="text-[15px] text-[#1B1C1E] break-keep">사용문의</p>
                                            </Link>
                                            <Link
                                                to="/support/notices"
                                                className="flex-1 bg-white rounded-[8px] flex flex-col items-center justify-center gap-[12px] flex-wrap py-[16px]"
                                            >
                                                <Parcel />
                                                <p className="text-[15px] text-[#1B1C1E] break-keep">공지사항</p>
                                            </Link>
                                            <Link
                                                to="/support/faq"
                                                className="flex-1 bg-white rounded-[8px] flex flex-col items-center justify-center gap-[12px] flex-wrap py-[16px]"
                                            >
                                                <Message />
                                                <p className="text-[15px] text-[#1B1C1E] break-keep">FAQ</p>
                                            </Link>
                                        </div>
                                    </div>

                                    <button
                                        type="button"
                                        onClick={handleLogout}
                                        className="text-[#5A5C63] text-[18px] font-[500] py-[24px] w-full text-center"
                                    >
                                        로그아웃
                                    </button>
                                    {isApp && <p className="text-center">{appVersion}</p>}
                                </div>
                            ) : (
                                <div className="mt-[24px] w-full responsive450:hidden">
                                    <ul className="flex min-h-[50px] ">
                                        <li
                                            className={`flex-1 flex cursor-pointer items-center justify-center text-[18px] font-bold ${activeTabIndex === 0 ? "bg-white text-[#FF7B2E] rounded-[8px_8px_0px_0px] border border-[#FF7B2E] border-b-transparent" : "bg-transparent text-[#878A93] border border-[transparent] border-b-[#FF7B2E]"}`}
                                            onClick={() => setactiveTabIndex(0)}
                                        >
                                            업체 정보
                                        </li>
                                        <li
                                            className={`flex-1 flex items-center justify-center text-[18px] font-bold cursor-pointer ${activeTabIndex === 1 ? "bg-white text-[#FF7B2E] rounded-[8px_8px_0px_0px] border border-[#FF7B2E] border-b-transparent" : "bg-transparent text-[#878A93] border border-[transparent] border-b-[#FF7B2E]"}`}
                                            onClick={() => setactiveTabIndex(1)}
                                        >
                                            주소록 관리
                                        </li>
                                        {cBefPrint === "Y" && (
                                            <li
                                                className={`flex-1 flex items-center justify-center text-[18px] font-bold cursor-pointer ${activeTabIndex === 2 ? "bg-white text-[#FF7B2E] rounded-[8px_8px_0px_0px] border border-[#FF7B2E] border-b-transparent" : "bg-transparent text-[#878A93] border border-[transparent] border-b-[#FF7B2E]"}`}
                                                onClick={() => setactiveTabIndex(2)}
                                            >
                                                송장 미리 출력하기
                                            </li>
                                        )}
                                    </ul>
                                    <div className="bg-white p-[40px] rounded-[0px_0px_16px_16px] border-r border-l border-b border-[#FF7B2E]">
                                        {activeTabIndex === 0 && (
                                            <div>
                                                <div className="flex">
                                                    <div className="flex-1">
                                                        <p className="text-[18px] text-[#1B1C1E]">거래처코드</p>
                                                        <p className="font-bold text-[24px] text-[#132E47] leading-[57px] mt-[8px]">
                                                            {infoData?.c_code}
                                                        </p>
                                                    </div>
                                                    <div className="flex-1">
                                                        <p className="text-[18px] text-[#1B1C1E]">사업자번호</p>
                                                        <p className="font-[500] text-[18px] text-[#132E47] leading-[57px] mt-[8px]">
                                                            {infoData?.c_company_number}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex flex-col gap-[20px] mt-[20px]">
                                                    <div className="grid grid-cols-[160px_1fr]">
                                                        <p className="leading-[36px] text-[18px] text-[#1B1C1E]">
                                                            상호명<span className="text-[#FF7B2E] ml-[5px]">*</span>
                                                        </p>
                                                        <div className="flex items-center gap-[8px]">
                                                            <p className="text-[18px] text-[#132E47]">{infoData?.c_company}</p>
                                                            <span className="text-[18px] text-[#FF7B2E] font-[500]">
                                                                {infoData?.c_no_yn === "신용" && infoData?.c_no_yn}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="grid grid-cols-[160px_1fr]">
                                                        <p className="leading-[36px] text-[18px] text-[#1B1C1E]">
                                                            연락처<span className="text-[#FF7B2E] ml-[5px]">*</span>
                                                        </p>
                                                        <p className="text-[18px] text-[#132E47] flex items-center">{infoData?.c_phone}</p>
                                                    </div>
                                                </div>
                                                <div className="flex flex-col mt-[20px]">
                                                    <p className="leading-[36px] text-[18px] text-[#1B1C1E]">
                                                        기본출발지주소설정<span className="text-[#FF7B2E] ml-[5px]">*</span>
                                                    </p>

                                                    {infoData && (
                                                        <form onSubmit={updateDefaultAddress}>
                                                            <div className="my-[10px] flex flex-col border rounded-lg overflow-hidden">
                                                                {departureList
                                                                    .filter(item => item.addr1)
                                                                    .map((item, i) => {
                                                                        console.log(item);
                                                                        return (
                                                                            <label
                                                                                key={item.value}
                                                                                className={`flex flex-col p-4 ${i < 2 ? "border-b" : ""} cursor-pointer bg-[#f7f7f8] [&:has(input:checked)]:bg-white`}
                                                                                htmlFor={item.value}
                                                                            >
                                                                                <div className="flex items-center gap-2">
                                                                                    <input
                                                                                        type="radio"
                                                                                        name="default-addr"
                                                                                        value={item.value}
                                                                                        id={item.value}
                                                                                        defaultChecked={
                                                                                            item.value === infoData.c_addr_defalt
                                                                                        }
                                                                                        className="peer appearance-none"
                                                                                    />
                                                                                    <Checked className="w-8 h-8 text-new peer-checked:!block hidden" />
                                                                                    <div className="w-[19px] h-[19px] border-gray-300 mx-[6.5px] rounded-full border-2 peer-checked:hidden" />
                                                                                    <div className="flex flex-col">
                                                                                        <p className="text-[18px] font-semibold text-[#1b1c1e] pb-1">
                                                                                            {item.title}
                                                                                        </p>
                                                                                        <p className="text-[#5a5c63]">
                                                                                            {item.addr1} {item.addr2}
                                                                                        </p>
                                                                                        <p className="text-[#1b1c1e] pt-1 font-bold">
                                                                                            담당 픽업기사
                                                                                            <span className="font-normal pl-2">
                                                                                                {item.name} {item.phone}
                                                                                            </span>
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </label>
                                                                        );
                                                                    })}
                                                            </div>
                                                            <button className="text-white bg-[#ff7b2e] text-[18px] py-[10px] rounded-[6px] w-full">
                                                                수정
                                                            </button>
                                                        </form>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {activeTabIndex === 1 && (
                                            <div>
                                                <AddressList
                                                    onSelect={handleAddressSelect}
                                                    onClose={() => {}}
                                                    isManage
                                                    className="p-0 max-h-[600px]"
                                                    buttonPlacement="top"
                                                />
                                            </div>
                                        )}
                                        {activeTabIndex === 2 && (
                                            <>
                                                {isPending && <ProgressSpinner message={printProgressMessage} />}

                                                <div className="flex flex-col gap-y-10">
                                                    <div className="flex flex-col">
                                                        <div className="leading-[38px] text-[28px] text-[#1B1C1E] font-bold border-b-2 border-[#1B1C1E] pb-3">
                                                            1. 출발지 선택
                                                        </div>

                                                        {infoData && (
                                                            <div className="mt-[20px] flex flex-col border rounded-lg overflow-hidden">
                                                                {departureList
                                                                    .filter(item => item.addr1)
                                                                    .map((item, i) => {
                                                                        return (
                                                                            <label
                                                                                key={item.value}
                                                                                className={`flex flex-col p-4 ${i < 2 ? "border-b" : ""} cursor-pointer bg-[#f7f7f8] [&:has(input:checked)]:bg-white`}
                                                                                htmlFor={item.value}
                                                                            >
                                                                                <div className="flex items-center gap-2">
                                                                                    <input
                                                                                        type="radio"
                                                                                        name="default-addr"
                                                                                        value={item.value}
                                                                                        id={item.value}
                                                                                        defaultChecked={item.value === form.value}
                                                                                        onChange={() => {
                                                                                            // console.log(item);
                                                                                            setForm(prev => ({ ...prev, ...item }));
                                                                                        }}
                                                                                        className="peer appearance-none"
                                                                                    />
                                                                                    <Checked className="w-8 h-8 text-new peer-checked:!block hidden" />
                                                                                    <div className="w-[19px] h-[19px] border-gray-300 mx-[6.5px] rounded-full border-2 peer-checked:hidden" />
                                                                                    <div className="flex flex-col">
                                                                                        <p className="text-[18px] font-semibold text-[#1b1c1e] pb-1">
                                                                                            {item.title}
                                                                                        </p>
                                                                                        <p className="text-[#5a5c63]">
                                                                                            {item.addr1} {item.addr2}
                                                                                        </p>
                                                                                        <p className="text-[#1b1c1e] pt-1 font-bold">
                                                                                            담당 픽업기사
                                                                                            <span className="font-normal pl-2">
                                                                                                {item.name} {item.tel}
                                                                                            </span>
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </label>
                                                                        );
                                                                    })}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="flex flex-col" ref={departureRef} style={{ scrollMarginTop: 120 }}>
                                                        <div className="leading-[38px] text-[28px] text-[#1B1C1E] font-bold border-b-2 border-[#1B1C1E] pb-3 mb-[20px]">
                                                            2. 도착지 선택
                                                        </div>

                                                        <div>
                                                            <SelectAddress
                                                                value={form.idx}
                                                                ref={selectAddressRef}
                                                                handleSelect={selectedItem => {
                                                                    // console.log(selectedItem);
                                                                    setForm(prev => ({
                                                                        ...prev,
                                                                        a_address: selectedItem.a_address,
                                                                        a_address_detail: selectedItem.a_address_detail ?? "",
                                                                        a_code: selectedItem.a_code ?? "",
                                                                        a_company: selectedItem.a_company,
                                                                        a_mobile: selectedItem.a_mobile ?? "",
                                                                        a_name: selectedItem.a_name ?? "",
                                                                        a_post: selectedItem.a_post,
                                                                        a_tel: selectedItem.a_tel,
                                                                        idx: selectedItem.idx,
                                                                    }));
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="flex flex-col">
                                                        <div className="leading-[38px] text-[28px] text-[#1B1C1E] font-bold border-b-2 border-[#1B1C1E] pb-3 mb-[20px]">
                                                            3. 운임 선택
                                                        </div>

                                                        <div className="flex items-center">
                                                            <p className="leading-[57px] text-[18px] text-[#1B1C1E] min-w-[160px]">
                                                                지불방법<span className="text-[#FF7B2E] ml-[5px]">*</span>
                                                            </p>
                                                            <div className="flex-1 flex">
                                                                <label className="flex-1 flex items-center gap-[10px]">
                                                                    <input
                                                                        type="radio"
                                                                        name="s_pay_kind"
                                                                        value="1"
                                                                        defaultChecked
                                                                        onChange={() => setForm(prev => ({ ...prev, s_pay_kind: "1" }))}
                                                                        className="peer appearance-none"
                                                                    />
                                                                    <Checked className="w-8 h-8 text-new peer-checked:!block hidden" />
                                                                    <div className="w-[19px] h-[19px] border-gray-300 mx-[6.5px] rounded-full border-2 peer-checked:hidden" />
                                                                    신용
                                                                </label>
                                                                {/* <label className="flex-1 flex items-center gap-[10px]">
                                                                    <input
                                                                        type="radio"
                                                                        name="s_pay_kind"
                                                                        value="3"
                                                                        onChange={() => setForm(prev => ({ ...prev, s_pay_kind: "3" }))}
                                                                        className="peer appearance-none"
                                                                    />
                                                                    <Checked className="w-8 h-8 text-new peer-checked:!block hidden" />
                                                                    <div className="w-[19px] h-[19px] border-gray-300 mx-[6.5px] rounded-full border-2 peer-checked:hidden" />
                                                                    착불
                                                                </label> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="flex flex-col">
                                                        <div className="leading-[38px] text-[28px] text-[#1B1C1E] font-bold border-b-2 border-[#1B1C1E] pb-3 mb-[20px]">
                                                            4. 수량
                                                        </div>

                                                        <div className="flex">
                                                            <p className="leading-[57px] text-[18px] text-[#1B1C1E] min-w-[160px]">
                                                                운송장 수량<span className="text-[#FF7B2E] ml-[5px]">*</span>
                                                            </p>
                                                            <div className="flex-1 flex flex-col gap-y-2">
                                                                <div className="flex-1 flex gap-3 p-[15px] flex border rounded-[8px] border-[#E1E2E4] [&:has(input:focus)]:ring-1 ring-[#FF7B2E]">
                                                                    <input
                                                                        type="text"
                                                                        name="bl_cnt"
                                                                        id="bl_cnt"
                                                                        value={form.bl_cnt}
                                                                        maxLength={3}
                                                                        onChange={e => {
                                                                            const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                                                            setForm(prev => ({ ...prev, bl_cnt: numericValue }));
                                                                        }}
                                                                        placeholder="수량을 입력해주세요."
                                                                        className="outline-none leading-[27px] flex-1 text-right"
                                                                    />
                                                                    <span className="text-[#878A93] text-[18px] font-[400]">장</span>
                                                                </div>
                                                                <p className="text-new text-[15px]">* 최대 출력 수량은 100장입니다.</p>
                                                                <p className="text-new break-keep text-[15px]">
                                                                    * QR 코드 생성 과정으로 인해 인쇄 완료 까지 다소 시간(1~2분)이 걸릴 수
                                                                    있습니다.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="flex gap-2">
                                                        <button
                                                            onClick={handleReset}
                                                            className="flex-1 text-[#878A93] border border-[#E1E2E4] text-[18px] py-[10px] rounded-[6px] w-full"
                                                        >
                                                            초기화
                                                        </button>
                                                        <button
                                                            disabled={isPending}
                                                            onClick={onClickPrint}
                                                            className="flex-1 text-white bg-[#ff7b2e] text-[18px] py-[10px] rounded-[6px] w-full"
                                                        >
                                                            {isPending ? "처리중" : "인쇄"}
                                                        </button>
                                                    </div>

                                                    {printData && (
                                                        <PrintColor
                                                            data={printData}
                                                            onClose={() => {
                                                                setPrintData(null);

                                                                setForm(prev => ({
                                                                    ...prev,
                                                                    bl_cnt: "",
                                                                }));
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </MorningLayout>
            </div>
            <Toaster position="bottom-center" reverseOrder={false} />
        </React.Fragment>
    );
}
